export const SET_PASSWORD_FORM = [

	// Step 1 - Change Password [START]
	{
		sections: [
			{
				label: 'invite.affiliate.form.section.heading',
				type: 'input',
				fields: [
					{
						name: 'choosePassword',
						key: 'invite.affiliate.form.choose.password',
						component: 'text',
						disableautofill: 'new-password',
						reference: 'password',
						required: true,
						validation: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*"£^()+={}\|?><,._])(?=.*[0-9])(?=.{10,16}$)/, // eslint-disable-line
					},
					{
						name: 'confirmPassword',
						key: 'invite.affiliate.form.confirm.password',
						component: 'text',
						disableautofill: 'new-password',
						reference: 'password',
						passwordCriteria: true,
						required: true,
						validation: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*"£^()+={}\|?><,._])(?=.*[0-9])(?=.{10,16}$)/, // eslint-disable-line
					}
				]
			}
		]
	}
];
